export const login = state => {
    var state1 = state.login;
    var ls = localStorage.getItem('login');
    var localStorageLogin = ls != null ? JSON.parse(ls) : state1;
    var loginResponse = localStorageLogin != null ? localStorageLogin : state.login;
    return loginResponse;
};

export const loading = state => {
    return state.loading;
};

export const unauthorized = state => {
    return state.unauthorized;
};

export const sessionExpired = state => {
    return state.sessionExpired;
};

export const type = state => {
  var state1 = state.type;
  var ls = localStorage.getItem('type');
  var localStorageLogin = ls != null ? JSON.parse(ls) : state1;
  var loginResponse = localStorageLogin != null ? localStorageLogin : state.type;
  return loginResponse;
};

export const prevType = state => {
  var state1 = state.prevType;
  var ls = localStorage.getItem('prevType');
  var localStorageLogin = ls != null ? JSON.parse(ls) : state1;
  var loginResponse = localStorageLogin != null ? localStorageLogin : state.prevType;
  return loginResponse;
};

export const visitorId = state => {
  var state1 = state.visitorId;
  var ls = localStorage.getItem('visitorId');
  var localStorageLogin = ls != null ? JSON.parse(ls) : state1;
  var loginResponse = localStorageLogin != null ? localStorageLogin : state.visitorId;
  return loginResponse;
};

export const prevPage = state => {
  return state.prevPage;
};

export const fromPath = state => {
  var state1 = state.fromPath;
  var ls = localStorage.getItem('from_path');
  var localStorageLogin = ls != null ? JSON.parse(ls) : state1;
  var loginResponse = localStorageLogin != null ? localStorageLogin : state.fromPath;
  return loginResponse;
};

export const prevPath = state => {
  return state.prevPath;
};

export const disqualified = state => {
  return state.disqualified;
};

export const addGroups = state => {
  return state.addGroups;
};

export const successMessage = state => {
  return state.successMessage;
};

export const alertMessage = state => {
  return state.alertMessage;
};

export const formID = state => {
  var state1 = state.formID;
  var ls = localStorage.getItem('formID');
  var localStorageLogin = ls != null ? JSON.parse(ls) : state1;
  var loginResponse = localStorageLogin != null ? localStorageLogin : state.formID;
  return loginResponse;
};
